import React from 'react'
import PropTypes from 'prop-types'

import SimpleHeader from './../block/SimpleHeader'

import { EditBlue, Clipboard, Building } from './../block/Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data, user, assets_path } = this.props

    return (
      <div
        className='bg-cover bg-center bg-no-repeat pb-[50px]'
        style={{ backgroundImage: `url(/${assets_path}/images/cartbg.svg)` }}
      >
        <div className='container leading-none'>
          <SimpleHeader
            title={`Юридическая информация`}
            user={user}
            lk_link={data?.lk_link}
          />
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[8px] text-center'>
            <div className='text-[18px] font-medium text-black flex items-center justify-center'>
              <EditBlue />
            </div>
            <div className='text-[18px] font-medium text-black flex items-center justify-center mt-[7px]'>
              Полное официальное наименование предприятия
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mt-[10px]'>
              Индивидуальный предприниматель Замятина Анастасия Сергеевна
            </div>
            <div className='text-[18px] font-medium text-black flex items-center justify-center mt-[10px]'>
              Сокращенное наименование
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mt-[10px]'>
              ИП Замятина А.С.
            </div>
          </div>
          <div className='flex justify-between items-center gap-[5px] mt-[5px]'>
            <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] text-center'>
              <div className='text-[18px] font-medium text-black flex items-center justify-center'>
                <Clipboard />
              </div>
              <div className='text-[18px] font-medium text-black flex items-center justify-center mt-[7px]'>
                ИНН
              </div>
              <div className='text-[14px] font-normal text-[#00000099] mt-[10px]'>
                644016390933
              </div>
            </div>
            <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] text-center'>
              <div className='text-[18px] font-medium text-black flex items-center justify-center'>
                <Clipboard />
              </div>
              <div className='text-[18px] font-medium text-black flex items-center justify-center mt-[7px]'>
                ОГРНИП
              </div>
              <div className='text-[14px] font-normal text-[#00000099] mt-[10px]'>
                325645700066409
              </div>
            </div>
          </div>
          <div className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center'>
            <div className='text-[18px] font-medium text-black flex items-center justify-center'>
              <Building />
            </div>
            <div className='text-[18px] font-medium text-black flex items-center justify-center mt-[7px]'>
              Юридический адрес
            </div>
            <div className='text-[14px] font-normal text-[#00000099] mt-[10px]'>
              412308, Саратовская обл., г. Балашов, проезд Коммунаров, д. 10
            </div>
          </div>
          <a href="/dostavka" className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[22px] text-center flex justify-between items-center'>
            <div className='text-black text-[16px]'>Доставка товаров</div>
            <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.353516 8.35352L4.35352 4.35352L0.353515 0.353516" stroke="black" strokeOpacity="0.6"/>
            </svg>
          </a>
          <a href="/polzovatelskoe-soglashenie" className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center flex justify-between items-center'>
            <div className='text-black text-[16px]'>Пользовательское соглашение</div>
            <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.353516 8.35352L4.35352 4.35352L0.353515 0.353516" stroke="black" strokeOpacity="0.6"/>
            </svg>
          </a>
          <a href="/politika" className='w-full bg-white rounded-[25px] px-[15px] py-[20px] mt-[5px] text-center flex justify-between items-center'>
            <div className='text-black text-[16px]'>Политика конфиденциальности</div>
            <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.353516 8.35352L4.35352 4.35352L0.353515 0.353516" stroke="black" strokeOpacity="0.6"/>
            </svg>
          </a>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  data: PropTypes.object,
  user: PropTypes.object,
  assets_path: PropTypes.string
}

export default Main